import {
	Configuration as ApiConfiguration,
	HighscoreEntryEntityControllerApi,
	RatingEntityControllerApi
} from 'mml-client-api';
import type { Configuration } from '../data/Configuration';

export const getHighscoreApi = (
	configuration: Configuration
): HighscoreEntryEntityControllerApi => {
	const apiConfig = new ApiConfiguration({
		basePath: configuration.backendUrl
	});
	return new HighscoreEntryEntityControllerApi(apiConfig);
};

export const getRatingApi = (
	configuration: Configuration
): RatingEntityControllerApi => {
	const apiConfig = new ApiConfiguration({
		basePath: configuration.backendUrl
	});
	return new RatingEntityControllerApi(apiConfig);
};
